'use strict';

var novicell = novicell || {};

novicell.siteNavigation = novicell.siteNavigation || new function () {
    this.init = function () {
        this.onWindowScroll();
        var siteNavigationToggle = document.getElementById('js-site-navigation-toggle');
        var siteNavigationList = document.getElementById('js-site-navigation-list');
        var serviceMenu = document.getElementById('js-service-menu');

        if (!siteNavigationToggle || !siteNavigationList) {
            return;
        }

        novicell.subNavigation.init(siteNavigationList);

        siteNavigationToggle.addEventListener('click', function (e) {
            e.preventDefault();
            novicell.helper.toggleClass(siteNavigationToggle, 'site-navigation-burger--active');
            novicell.helper.toggleClass(siteNavigationList, 'site-navigation-list--open');
            novicell.helper.toggleClass(document.body, 'no-scroll');

            if(serviceMenu != undefined) {
                novicell.helper.toggleClass(serviceMenu, 'service-menu--open');
            }
        });
    };

    const stickyClass = 'site-navigation--sticky';
    let isSticky = false;

    this.onWindowScroll = function () {
        var siteNavigationsticky = 80;

        if (window.pageYOffset > siteNavigationsticky && !isSticky) {
            isSticky = true;
            document.body.classList.add(stickyClass);
        } else if (window.pageYOffset < siteNavigationsticky && isSticky) {
            isSticky = false;
            document.body.classList.remove(stickyClass);
        }
    };
};
